export const SET_NOTIFICATION = 'NOTIFICATIONS/SET_NOTIFICATION';
export const SET_NOTIFICATION_SITUATIONS = 'NOTIFICATIONS/SET_NOTIFICATION_SITUATIONS';
export const SET_CURRENT_NOTIFICATION_FILTER_ID = 'NOTIFICATIONS/SET_CURRENT_NOTIFICATION_FILTER_ID';
export const SET_CURRENT_PREVISION_FILTER_ID = 'NOTIFICATIONS/SET_CURRENT_PREVISION_FILTER_ID';
export const SET_IS_LOADING = 'NOTIFICATIONS/SET_IS_LOADING';